import gql from 'graphql-tag'

export const GET_ADDRESS = gql`
query QueryType {
    addressCategories {
      isSuccessful
      message
      addressCategories {
        companyId
        srcTable
        srcColumn
        text
        hasRelation
      }
    }
  }`

export const ADDRESS_MUTATION_CREATE = gql`
mutation MutationType($input: CreateLookupInputSimple!) {
    createAddressCategory(input: $input) {
      isSuccessful
      message
      addressCategory {
        companyId
        srcTable
        srcColumn
        text
      }
    }
  }`

export const ADDRESS_MUTATION_DELETE = gql`
mutation DeleteAddressCategory($input: DeleteLookupInputSimple!) {
    deleteAddressCategory(input: $input) {
      isSuccessful
      message
      addressCategory {
        companyId
        srcTable
        srcColumn
        text
      }
    }
  }`

export const ADDRESS_MUTATION_UPDATE = gql`
mutation UpdateAddressCategory($input: UpdateLookupInputSimple!) {
    updateAddressCategory(input: $input) {
      isSuccessful
      message
      addressCategory {
        companyId
        srcTable
        srcColumn
        text
      }
    }
  }
`
